import normalized from 'normalize.css';
import React, {FC, memo} from 'react';
import {createGlobalStyle} from 'styled-components';

import {useCss} from '../css/cssContext';
import {fonts, fontSizes} from './fontStyles';
import {scrollbar} from './mixins';

// Avoid removing and re-inserting global styles unnecessarily,
// because it may cause major style recalculation issues.
const GlobalStyle = memo(createGlobalStyle`
  html,
  body {
    font-family: ${fonts.system};
    font-size: ${fontSizes.medium};
    color: ${(p) => p.theme.greys.shade80};
    height: 100%;
    padding: 0;
    margin: 0;
    line-height: 1.2;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    ${(p) => scrollbar(p.theme.alphas.black20, p.theme.alphas.black30, p.theme.alphas.black40)};
  }

  div[contenteditable], input {
    text-rendering: auto !important;
  }

  /*
   * Prevent bounce scroll on root element.
   */

  html {
    overflow: hidden;
  }

  body {
    overflow: auto;
  }
  
  /*
   * Reset.
   */

  * {
    user-select: none;
    cursor: default;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  *:focus {
    outline: none;
  }

  *:not(body) {
    background-repeat: no-repeat;
  }

  a {
    text-decoration: none;
  }

  /*
   * Layers.
   */

  .layer {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  grammarly-editor-plugin {
    --grammarly-button-position-right: 60px;
    --grammarly-button-position-bottom: 60px;
  }
`);

export const GlobalStyles: FC = () => {
  useCss(normalized);
  return <GlobalStyle />;
};
